import { isElementTypeContainer } from '@/common/converter/utils/element'

export const getContextProperty = (elementList = []) => {
  const element = elementList.find(isElementTypeContainer) ?? {}

  return element?.contextProperty ?? {}
}
